import { authService } from '../../api/auth';
import { userService } from '../../helpers/fakebackend/user.service';
import router from '../../router/index'

const user = JSON.parse(localStorage.getItem('user'));
export const state = user
    ? { status: { loggeduser: true }, user }
    : { status: {}, user: null };

export const actions = {
    // Logs in the user.
    // eslint-disable-next-line no-unused-vars
    async login({ dispatch, commit }, { email, password }) {
        commit('loginRequest', { email });

        try {
            const user = await authService.login(email, password);
            commit('loginSuccess', user);
            router.push('/');
        } catch (error) {
            commit('loginFailure', error.message);
            dispatch('notification/error', error.message, { root: true });
        }
    },
    // Logout the user
    async logout({ commit }) {
        await authService.logout();
        commit('logout');
    },
    // register the user
    registeruser({ dispatch, commit }, user) {
        commit('registerRequest', user);
        // Note: Register functionality would need to be implemented in authService
        // For now, keeping the original fake backend service
        userService.register(user)
            .then(
                user => {
                    commit('registerSuccess', user);
                    dispatch('notification/success', 'Registration successful', { root: true });
                    router.push('/login');
                },
                error => {
                    commit('registerFailure', error);
                    dispatch('notification/error', error, { root: true });
                }
            );
    }
};

export const mutations = {
    loginRequest(state, user) {
        state.status = { loggingIn: true };
        state.user = user;
    },
    loginSuccess(state, user) {
        state.status = { loggeduser: true };
        state.user = user;
    },
    loginFailure(state) {
        state.status = {};
        state.user = null;
    },
    logout(state) {
        state.status = {};
        state.user = null;
    },
    registerRequest(state) {
        state.status = { registering: true };
    },
    registerSuccess(state) {
        state.status = {};
    },
    registerFailure(state) {
        state.status = {};
    }
};

export const getters = {
    isLoggedIn: (state) => {
        return !!(state.user && state.user.access_token && state.status.loggeduser);
    },
    currentUser: (state) => {
        return state.user;
    },
    isLoggingIn: (state) => {
        return state.status.loggingIn || false;
    }
};

